import script from "./UserDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserDialog.vue?vue&type=style&index=0&id=74e521f8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e521f8"]])

export default __exports__